<template>
    <div class="tabs-layout">
        <ul class="menu-tabs">
            <li :class="getActiveTabClass('medical')" @click="OpenTab('medical')">
                <common-icon name="timeline" size="tiny"></common-icon>
                <p class="patient-profile-sidebar">{{ $t('modals.patient.tab.label_one') }}</p>
            </li>
            <li :class="getActiveTabClass('details')" @click="OpenTab('details')">
                <common-icon name="document" size="tiny"></common-icon>
                <p class="patient-profile-sidebar">{{ $t('modals.patient.tab.label_two') }}</p>
            </li>
            <li :class="getActiveTabClass('profile')" @click="OpenTab('profile')">
                <common-icon name="user" size="tiny"></common-icon>
                <p class="patient-profile-sidebar">{{ $t('modals.patient.tab.label_three') }}</p>
            </li>
            <li :class="getActiveTabClass('summary')" @click="OpenTab('summary')">
                <common-icon name="summary" size="tiny"></common-icon>
                <p class="patient-profile-sidebar">{{ $t('modals.patient.tab.label_four') }}</p>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                activeTab: 'details',
            }
        },
        methods: {
            OpenTab(modalName) {
                this.$emit('toggle', modalName)
                this.activeTab = modalName
            },

            getActiveTabClass(activeTab) {
                return {
                    'active-tab': this.activeTab === activeTab,
                    'disabled-tab': activeTab === 'medical' || activeTab === 'summary',
                }
            },
        },
    }
</script>
<style scoped lang="scss">
    @import 'styles/components/patients/_patient';

    .menu-tabs {
        display: flex;
        justify-content: space-between;
        gap: 8px;
        padding: 4px;
        border-radius: 8px;
        list-style: none;
    }

    .menu-tabs li {
        padding: 8px 16px;
        cursor: pointer;
        border-radius: 8px;
        font-size: 12px;
        display: flex;
        justify-content: center;
        color: oklch(0.145 0 0);
        align-items: center;
        width: 268px;
        align-items: center;
    }

    .menu-tabs li.active-tab {
        background-color: #007bff;
        color: #fff;
        width: 268px;
        border-radius: 10px;
        font-weight: 500;
    }

    .menu-tabs li.disabled-tab {
        cursor: not-allowed;
        opacity: 0.5;
        pointer-events: none;
    }

    /* ✅ Responsive styles */
    @media (max-width: 1024px) {
        .menu-tabs {
            gap: 6px;
        }

        .menu-tabs li {
            width: 48%; /* Two tabs per row on tablets */
            font-size: 13px;
            padding: 10px;
        }
    }

    @media (max-width: 600px) {
        .menu-tabs li.active-tab {
            font-weight: 600;
        }

        .patient-profile-sidebar {
            display: none;
        }
    }
</style>
